<template>

  <div class="padded">
    <el-row>
      <el-col align="left">
        <edit-pane v-if="!hidePanel" ref="ep" prefix="Agreement: ":title="form.name"
        :is-edit="editMode"
        @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onAdd" />

        <el-form ref="agreementDetailsForm" :model="form" label-position="top">

          <text-input
          label="Name"
          prop="name"
          v-model="form.name"
          :disabled="disabled"
          placeholder="Name of agreement (must be unique)" />


          <h4>Structure Details</h4>
          <el-row justify="left" :gutter="16">

            <el-col :span="12">
              <select-input
               label="Status"
               prop="status"
               v-model="form.status"
               :list="[{label: 'Active', value: 'Active'}, {label: 'Inactive', value: 'Inactive'}]"
               :disabled="disabled"  />
            </el-col>

            <el-col :span="12">
              <text-input
              label="Category"
              prop="category"
              v-model="form.category"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <text-input
              label="Allowed Heights"
              prop="heights"
              v-model="form.heights"
              suffix="m."
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <number-input
              label="Min. Height"
              prop="minHeight"
              :decimals="0"
              suffix="m."
              v-model="form.minHeight"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <number-input
              label="Max. Height"
              prop="maxHeight"
              :decimals="0"
              suffix="m."
              v-model="form.maxHeight"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <text-input
              label="Structure Types"
              prop="structures"
              v-model="form.structures"
              :disabled="disabled"  />
            </el-col>
          </el-row>


          <h4>Sharer Details</h4>
          <el-row justify="left">

            <el-col :span="6">
              <number-input
              label="From Sharers"
              prop="fromSharers"
              :decimals="0"
              v-model="form.fromSharers"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <number-input
              label="To Sharers"
              prop="toSharers"
              :decimals="0"
              v-model="form.toSharers"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <switch-input
              label="Only First Sharer"
              prop="firstSharerOnly"
              v-model="form.firstSharerOnly"
              :disabled="disabled"  />
            </el-col>

            <el-col :span="6">
              <switch-input
              label="Rates Sharer No."
              prop="ratesBySharerNo"
              v-model="form.ratesBySharerNo"
              :disabled="disabled || form.ratesBySharerQty"  />
            </el-col>

            <el-col :span="6">
              <switch-input
              label="Rates Sharer Qty"
              prop="ratesBySharerQty"
              v-model="form.ratesBySharerQty"
              :disabled="disabled || form.ratesBySharerNo"  />
            </el-col>

          </el-row>

          <h4>Rates</h4>
          <el-row style="width: inherit; max-width: 1235px">
            <el-col :span="24">
              <el-table
                 :data="form.rates"
                 border
                 stripe
                 style="width: 100%">

                 <el-table-column prop="seqNo"
                  label="#">
                 </el-table-column>

                 <el-table-column label="Months">
                   <el-table-column prop="fromMonth"
                    label="From"
                    :formatter="formatInt">
                   </el-table-column>

                   <el-table-column prop="toMonth"
                   label="To"
                    sortable
                    align="right"
                    :formatter="formatInt">
                   </el-table-column>
               </el-table-column>

                 <el-table-column label="Sharers">
                     <el-table-column
                        prop="telco1"
                        label="1"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco2"
                        label="2"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco3"
                        label="3"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco4"
                        label="4"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco5"
                        label="5"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco6"
                        label="6"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>

                     <el-table-column
                        prop="telco7"
                        label="7"
                        sortable
                        align="right"
                        :formatter="formatNum">
                     </el-table-column>
               </el-table-column>

               </el-table>
             </el-col>
           </el-row>


        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import ElTableMixins from '@/mixins/ElTableMixins'
import PostMixins from '@/mixins/PostMixins'
import SelectRateCategory from '@/components/atoms/selects/SelectRateCategory'

export default {
  mixins: [ElTableMixins, PostMixins],

  components: {
    SelectRateCategory
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'agreements-table'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    resetData () {
      this.form = this.getTableStruct('agreements')
    },

    success (response) {
      this.$events.fire(this.tableRef + '-refresh-table')
      this.resetData()
    },

    error (response) {
      console.error(response)
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.form.id = null
      this.disabled = false
      this.onSave()
    },

    onSave () {

      this.saveForm(this, '/agreements', (this.adding ? null : this.form.id), this.form, this.form.name, this.success, this.error)
      this.disabled = true
      //      this.resetData()
    },

    onClose () {
      this.resetData()
    }
  },

  data () {
    return {
      disabled: true,
      form: this.adding ? this.getTableStruct('agreements') : this.rowData
    }
  }
}

</script>
